//
// bugsnagやlogtailのログでユーザー名を使いたいが、ユーザー情報を引数で渡す形が難しいケースが多い。
// 堅牢ではないが、Auth0のユーザー情報をlocalStorageに入れてしまい、それを使い回す形にする
//
import { z } from 'zod'

const PARTIAL_AUTH0_RESPONSE = 'PARTIAL_AUTH0_RESPONSE'

const auth0Schema = z.object({
  email: z.string(),
  sub: z.string(),
  name: z.string(),
})

type Auth0User = z.infer<typeof auth0Schema>

/** localStorage から 'PARTIAL_AUTH0_RESPONSE' を取得する */
export function getAuth0UserFromLocalStorage(): Auth0User | undefined {
  try {
    const cache = localStorage.getItem(PARTIAL_AUTH0_RESPONSE)
    if (cache === null) {
      return
    }
    const auth0User = JSON.parse(cache) as unknown
    return auth0Schema.parse(auth0User)
  } catch {}
}

/** localStorage に 'PARTIAL_AUTH0_RESPONSE' を設定する */
export const setPartialAuth0ResponseToLocalStorage = (auth0User: {
  email: string | undefined
  email_verified: boolean | undefined
  exp: number | undefined
  updated_at: string | undefined
  family_name: string | undefined
  given_name: string | undefined
  name: string | undefined
  nickname: string | undefined
  sub: string | undefined
}): void => {
  localStorage.setItem(PARTIAL_AUTH0_RESPONSE, JSON.stringify(auth0User))
}

/**
 * 最後に使用した認証方法を取得する
 * @returns {'salesforce' | 'google' | 'hubspot' | 'password' | undefined} 認証プロバイダー
 * - localStorage に"PARTIAL_AUTH0_RESPONSE"が存在しない場合は undefined
 * - パターンに当てはまらないケースはすべて'password'とみなす
 */
export const getLastUsedAuth = (
  auth0User: { sub: string } | undefined,
): 'salesforce' | 'google' | 'hubspot' | 'password' | undefined => {
  const auth0UserSub = auth0User?.sub
  if (auth0UserSub === undefined) {
    return
  }
  if (auth0UserSub.startsWith('salesforce')) {
    return 'salesforce'
  }
  if (auth0UserSub.startsWith('google-oauth2')) {
    return 'google'
  }
  if (auth0UserSub.startsWith('oauth2|hubspot')) {
    return 'hubspot'
  }
  return 'password'
}
